import { useDashboard } from './dashboard.provider'
import DashboardPatientMedEventList from './dashboard-patient-medevent-list/dashboard-patient-medevent-list.component'
import { useTranslation } from 'react-i18next'
import DashboardSelectedPatientMedEvent from './dashboard-selected-patient-medevent/dashboard-selected-patient-medevent.component'

const DashboardBody = () => {
  const { dashboardPatientMedEventListToShow } = useDashboard()
  const { t } = useTranslation()

  const AllPatientsDoneImage = () => {
    return (
      <div className="c-flex c-flex-col c-flex-grow c-items-center c-p-4 c-justify-center c-w-full c-text-3xl c-mt-14">
        <h2 className="c-font-nexa c-text-xl c-font-bold">{t('pages.dashboard.all-done')}</h2>
        <div className="c-relative c-w-full c-max-w-[460px] c-flex-grow">
          <img width="461" height="464" src="/assets/img/dashboard-all-done.svg" alt="all done image" />
        </div>
      </div>
    )
  }

  return (
    <div className="c-flex c-flex-grow c-max-h-full c-border-t c-border-grey-200 c-overflow-auto">
      {dashboardPatientMedEventListToShow.length === 0 ? (
        <AllPatientsDoneImage />
      ) : (
        <div className="c-flex c-flex-grow">
          <DashboardPatientMedEventList />
          <DashboardSelectedPatientMedEvent />
        </div>
      )}
    </div>
  )
}

export default DashboardBody
